export default {
  save: "Opslaan",
  cancel: "Annuleren",
  create: "{{item}} aanmaken",
  delete: "{{item}} verwijderen",
  deleteSimple: "Verwijderen",
  require: "Configureer eerst `{{item}}`",
  search:" Zoeken",
}
